import React, { Component } from "react";
import "../assets/css/styles.css";
import InfoDropdown from "./InfoDropdown";

class Navbar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...props,
      infoHidden: true,
    };


  }

  // componentDidUpdate() {
  //   localStorage.setItem('NavbarState', JSON.stringify(this.state))
  // }

  // componentDidMount() {
  //   this.NavbarUpdatedState = JSON.parse(localStorage.getItem('NavbarState'))
  //   if (localStorage.getItem('NavbarState')) {
  //     this.setState({
  //       infoHidden: this.NavbarUpdatedState.infoHidden,
        
  //      })
  //   } else {
  //     this.setState({
        
  //       infoHidden: true,
  
  //     })
  //    }
  // }


  render() {
    const { infoHidden } = this.state;

    const toggleInfoButton = () => [
      this.setState({ infoHidden: !this.state.infoHidden }),
      
    ];

    return (
      <div>
        <nav
          className={"navbar navbar-expand-lg navbar-dark fixed-top "}
          id="mainNav"
        >
          <div className="container">
            <a className="navbar-brand js-scroll-trigger" >
              <i className="fas fa-plane" />
            </a>
            <button
              onClick={toggleInfoButton}
              className="navbar-toggler navbar-toggler-right"
              type="button"
              data-toggle="collapse"
              data-target="#navbarResponsive"
              aria-controls="navbarResponsive"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <i
                className={infoHidden ? "fas fa-info" : "fas fa-times  "}
                ariaHidden="true"
              />
            </button>
            <div
              className={"collapse navbar-collapse"}
              data-toggle="collapse"
              data-target="#navbarResponsive"
            >
              <ul className="navbar-nav text-uppercase ml-auto">
                <li className="nav-item">
                  <a onClick={toggleInfoButton} className="nav-link js-scroll-trigger navBarItemPointer">
                    How it works
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>

        <InfoDropdown
        {...this.state}
        />
      </div>
    );
  }
}

export default Navbar;
